import { useEffect, useState } from "react";
import { getProductsFromCachedBasketCookie } from "../../../utils/product";

const BASKET_QTY_UPDATED_EVENT = "jl-events.browser.basketQuantityUpdated";

export const useCachedBasketData = () => {
  const [cachedBasketData, setCachedBasketData] = useState({ products: [] });

  const updateCachedBasketData = () => {
    setCachedBasketData(getProductsFromCachedBasketCookie());
  };

  useEffect(() => {
    updateCachedBasketData();
    window.addEventListener(BASKET_QTY_UPDATED_EVENT, updateCachedBasketData);

    return () => {
      window.removeEventListener(
        BASKET_QTY_UPDATED_EVENT,
        updateCachedBasketData,
      );
    };
  }, []);

  return cachedBasketData;
};
